module.exports = __webpack_public_path__ + "static/media/portrait-4.92cdd2ec.jpg";